/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem, Box } from "@mui/material";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData, postData } from "utils/Gateway";
import { replaceListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";

import ChallengesCommonHeader from "components/ChallengeComponents/Common/Header/ChallengesCommonHeader";
import ChallengeListHeader from "../ChallengeListHeader/ChallengeListHeader";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import ChallengeListFilterPopup from "../Popup/ChallengeListFilterPopup";
import { assetImages } from "constants";
import { useTranslation } from "react-i18next";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import ChallengeTypeModal from "../Modals/ChallengeTypeModal";
import ChallengeTypeOptions from "data/Challenge/ChallengeType.json";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import AddFollowerModal from "components/Common/Modal/AddFollowerModal";

const ChallengeListBody = () => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");
  const { t, i18n } = useTranslation(); //for translation

  const [isLoading, setIsLoading] = useState(false);
  const [jobList, setJobList] = useState([]);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedJobIds, setSelectedJobIds] = useState([]);

  //filter requirements
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]); // json filter query
  const [reloadData, setReloadData] = useState(false); // reload data
  const [isFilterReset, setIsFilterReset] = useState(false); // filter reset

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [selectedChallengeId, setSelectedChallengeId] = useState(null);
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const [selectedTagId, setSelectedTagId] = useState(null);

  //function for get project list
  const getAllChallenges = async () => {
    setRowSelection({});
    setSelectedJobIds([]);
    setIsLoading(true);

    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_CHALLENGE}?token=${token}&modulefrom=backend`;

      console.log(requestUrl);

      const response = await getData(requestUrl);
      setIsLoading(false);

      console.log(response);

      if (response.status) {
        setMessageType("success");
        setJobList(response.data);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }
    setShowAlert(true);
  };

  //function for get filtered challenges
  const getFilteredChallenges = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_FILTERED_CHALLENGE +
        `?token=${token}&modulefrom=backend`;

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      setIsLoading(false);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setJobList(response.data);
        setMessageType("success");
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      console.log(error.message);
      setMessageType("error");
      setAlertMessage(error.message);
    }
    setShowAlert(true);
  };

  //function for change rank
  const rankInputChangeHandler = (row, value) => {
    const updatedJobList = [...jobList];

    const rowIndex = updatedJobList.findIndex(
      (jobData) => jobData._id === row.original._id
    );

    if (rowIndex !== -1) {
      updatedJobList[rowIndex].rank = value;
      setJobList(updatedJobList);
    }
  };

  //function for update challenge
  const updateBulkChallengeHandler = async () => {
    if (selectedJobIds.length > 0) {
      try {
        const jobListToBeUpdate = jobList.filter((item) =>
          selectedJobIds.includes(item._id)
        );

        let jobData = {
          challengelist: jobListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL + url.API_UPDATE_BULK_CHALLENGE + `?token=${token}`;

        const response = await putData(requestURL, jobData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            getAllChallenges();
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select atleast one challenge");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for delete challenge
  const deleteBulkChallengeHandler = async () => {
    if (selectedJobIds.length > 0) {
      try {
        const jobListToBeDelete = jobList.filter((item) =>
          selectedJobIds.includes(item._id)
        );

        let jobData = {
          challengelist: jobListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_CHALLENGE + `?token=${token}`;

        const response = await putData(requestURL, jobData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            getAllChallenges();
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select atleast one challenge");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const removeTagFromChallenge = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_LABEL_CHALLENGE;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedChallengeId(null);
      }, 1000);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setJobList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  //function for reset filter
  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  //use effect for search filter popup
  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getFilteredChallenges();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllChallenges();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    getAllChallenges();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: t("Title"),
        size: 250,
      },
      // tags
      {
        accessorKey: "tags", // Assuming 'tags' will be an array of objects like in CRMLeadListBody
        header: t("Label"),
        size: 300,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.tags && row.original.tags.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.tags &&
                    row.original.tags.map((tag, index) => (
                      <li key={index} className="d-inline-flex">
                        <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                          <span className="badge-text fs-xs fw-medium me-1">
                            {tag.title}
                          </span>
                          <Link
                            to="#"
                            className={`${
                              tag.moderator.toString() ===
                                userInfo._id.toString() ||
                              userInfo.role.slug === "ADMIN" ||
                              userInfo.role.slug === "SUPER_ADMIN"
                                ? "d-block"
                                : "d-none"
                            }`}
                            onClick={() => {
                              setSelectedChallengeId(row.original._id);
                              setSelectedTagId(tag._id);
                              removeTagFromChallenge(
                                [tag._id],
                                row.original._id
                              );
                            }}
                          >
                            {selectedTagId &&
                            selectedTagId === tag._id &&
                            selectedChallengeId &&
                            selectedChallengeId === row.original._id ? (
                              <div
                                className="spinner-border spinner-border-sm text-primary ms-1"
                                role="status"
                                style={{ height: "12px", width: "12px" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <span
                                className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                                style={{ cursor: "pointer" }}
                              >
                                cancel
                              </span>
                            )}
                          </Link>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedJobIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "challengetype",
        header: t("Type"),
        Cell: ({ row }) => {
          const challengeTypeValue = row.original.challengetype;
          // Find matching label from ChallengeTypeOptions or default to "Talent Hunt"
          const typeOption = ChallengeTypeOptions.find(
            (type) => type.value === challengeTypeValue
          );
          const displayLabel = typeOption ? typeOption.label : "Talent Hunt";

          return <span>{displayLabel}</span>;
        },
      },
      {
        accessorKey: "challengeresponsecount",
        header: t("Responses"),
      },
      //rank
      {
        accessorKey: "rank",
        header: t("Rank"),
        Cell: ({ row }) => (
          <div className="ranking border-bottom-0">
            <input
              type="text"
              className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
              style={{ width: "80px" }}
              value={row.original.rank}
              onChange={(e) => rankInputChangeHandler(row, e.target.value)}
            />
          </div>
        ),
      },
      // posted by
      {
        accessorKey: "moderatorname",
        header: t("Posted By"),
        size: 200,
        Cell: ({ row }) => (
          <div className="d-flex border-bottom-0">
            <div className="d-flex align-items-center gap-2">
              <div
                className="avatar rounded-circle overflow-hidden"
                style={{ width: "25px", height: "25px" }}
              >
                <img
                  src={
                    row.original.moderatorimage == ""
                      ? assetImages.defaultUser
                      : url.SERVER_URL + row.original.moderatorimage
                  }
                  alt="admin"
                  className="w-100 h-100 object-fit-cover object-center"
                />
              </div>
              <p>{row.original.moderatorname}</p>
            </div>
            <button
              onClick={() => {
                createContactChatHandler(
                  row.original.moderator,
                  "MOD_CHALLENGE",
                  row.original._id,
                  row.original.name
                );
              }}
              className={
                row.original.moderator?.toString() === userInfo._id.toString()
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        ),
      },
      //follower  //follower
      {
        accessorKey: "followersnames",
        header: t("Followers"),
        size: 250,
        Cell: ({ row }) =>
          row.original.followerslist.map((follower, index) => (
            <div
              className="owner border-bottom-0 d-flex gap-1 mb-1"
              key={index}
            >
              <img
                className="rounded-circle"
                height={15}
                width={15}
                src={
                  follower.image == ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + follower.image
                }
                alt="Babcock"
              />

              <p>
                <span className="d-block">{follower.fullname}</span>
              </p>
              {/* <button
                      onClick={() => {
                        createContactChatHandler(row.original._id);
                      }}
                      className={
                        follower._id === userInfo._id
                          ? "d-none"
                          : "d-flex align-items-center ms-auto border-0 bg-light"
                      }
                    >
                      <span className="d-block material-symbols-outlined icon-md text-primary">
                        chat
                      </span>
                    </button> */}
            </div>
          )),
      },
      {
        accessorKey: "postededdate",
        header: t("Posted on"),
      },
      {
        accessorKey: "jobcode",
        header: t("Code"),
      },
      {
        accessorKey: "jobtype",
        header: t("Job Type"),
      },
      {
        accessorKey: "companynamestring",
        header: t("Company"),
      },
      {
        accessorKey: "minsalary",
        header: t("Min Salary"),
      },
      {
        accessorKey: "maxsalary",
        header: t("Max Salary"),
      },
      {
        accessorKey: "paymentduration",
        header: t("Payment Type"),
      },
      {
        accessorKey: "remotejob",
        header: t("Remote Job"),
      },
      {
        accessorKey: "city",
        header: t("City"),
      },
      {
        accessorKey: "requiredskillstring",
        header: t("Required Skills"),
      },
      {
        accessorKey: "optionalskillstring",
        header: t("Optional Skills"),
      },
    ],
    [jobList, i18n.language, selectedTagId, selectedChallengeId]
  );

  useEffect(() => {
    //do something when the row selection changes...
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedJobIds(selectedIdsArray);
    } else {
      setSelectedJobIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_CHALLENGE")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">
          <ChallengesCommonHeader componentName="challengelist" />

          <div className="container-fluid px-lg-5">
            {/* <div className="gradient-dark px-3 py-2 fs-lg fw-semibold text-white d-flex align-items-center justify-content-between gap-3 flex-wrap rounded-10">
            <span>
              You have not added your skills tet please add skills to add
              challenges
            </span>
            <button
              type="button"
              className="btn btn-gray"
              data-bs-toggle="modal"
              data-bs-target="#addDetails"
            >
              Add Details
            </button>
          </div> */}

            {/* ------------- header section ---------------- */}
            <ChallengeListHeader
              reloadList={resetFilterData}
              updateRankHandler={updateBulkChallengeHandler}
              changeStatusHandler={deleteBulkChallengeHandler}
              selectedJobIds={selectedJobIds}
              jsonFilterQuery={jsonFilterQuery}
            />

            {/* --------- table section ------------- */}
            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={jobList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection }} //pass our managed row selection state to the table to use
                  enableRowActions // show the action column
                  renderRowActionMenuItems={({ row }) => [
                    <MenuItem key="details">
                      <Link to={`/admin/challenges/jobinformation/${row.id}`}>
                        {t("View Details")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="process">
                      <Link to={`/admin/challenges/hiringprocess/${row.id}`}>
                        {t("View Hiring Process")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="team">
                      <Link to={`/admin/challenges/hiringteam/${row.id}`}>
                        {t("View Hiring Team")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="response">
                      <Link to={`/admin/challenges/responses/list/${row.id}`}>
                        {t("View Responses")}
                      </Link>
                    </MenuItem>,
                    // <MenuItem key="survey">
                    //   <Link to={`/admin/challenges/survey/${row.id}`}>
                    //     {t("View Survey")}
                    //   </Link>
                    // </MenuItem>,
                  ]} // action columns menu items
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        {/* ======== popups and modals area ======== */}
        {/* ------ add label modal-------- */}
        <AddLabelModal
          moduleName="challenge"
          afterTagModalClose={afterModalActionClose}
          selectedIds={selectedJobIds}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* -------- filter popup ------------- */}
        <ChallengeListFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={resetFilterData}
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
          moduleSlug="challengelist"
        />

        {/* ----------- delete warning modal ------------ */}
        <DeleteWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectedJobIds([]);
          }}
          onDelete={deleteBulkChallengeHandler}
          moduleName={t("challenge")}
        />

        {/* Challenge Type Selection Modal */}
        <ChallengeTypeModal />

        <AddFollowerModal
          moduleName="challengelist"
          selectedIds={selectedJobIds}
          afterModalClose={afterModalActionClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          onModalClose={() => {
            setRowSelection({});
            setSelectedJobIds([]);
          }}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default ChallengeListBody;
